import { render } from "./MainWeek.vue?vue&type=template&id=a758b72e"
import script from "./MainWeek.vue?vue&type=script&lang=js"
export * from "./MainWeek.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__